// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"1d56473d","270":"0924331e","458":"79f1113f","556":"7557899a","834":"21cb9cd2","847":"21c0559c"}[chunkId] + ".chunk.js";
};